<template>
	<div>
		<div v-if="/pdf/i.test(selectedFile.extension)" class="pdfWrapper">
			<pdfViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/xl/gi.test(selectedFile.extension)" class="xlsxWrapper">
			<xlsxViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/txt/gi.test(selectedFile.extension)" class="txtWrapper">
			<txtViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/csv/gi.test(selectedFile.extension)" class="csvWrapper">
			<csvViewer :selectedFile="selectedFile" />
		</div>
		<div v-else-if="/html/gi.test(selectedFile.extension)" class="htmlWrapper">
			<htmlViewer :selectedFile="selectedFile" />
		</div>
		<v-btn
			color="green darken-1"
			small
			absolute
			top
			right
			fab
			@click="downloadOriginalFile"
		>
			<v-icon>get_app</v-icon>
		</v-btn>
	</div>
</template>

<script>
import pdfViewer from '../../components/pdfViewer';
import xlsxViewer from '../../components/xlsxViewer';
import txtViewer from '../../components/textViewer';
import csvViewer from '../../components/csvViewer';
import htmlViewer from '../../components/htmlViewer';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
export default {
	created() {},
	components: {
		pdfViewer,
		xlsxViewer,
		txtViewer,
		csvViewer,
		htmlViewer,
	},
	data() {
		return {};
	},
	methods: {
		// ...mapMutations("rejectedMeta", ["closeFileMetaDialog"]),
		...mapActions('rejectedMeta', ['downloadFile']),
		downloadOriginalFile() {
			this.downloadFile().then(data => {});
		},
	},
	computed: {
		...mapGetters('rejectedMeta', ['selectedFile']),
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.pdfWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.xlsxWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.txtWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.csvWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.htmlWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
</style>
